export interface SupportImpersonationSession {
  token: string;
  sessionId: string;
  targetUserId: string;
  targetEmail: string;
  targetName: string | null;
  targetCompanyName: string | null;
  reason: string | null;
  startedAt: string;
  expiresAt: string;
}

const STORAGE_KEY = 'support-impersonation-session';
export const SUPPORT_IMPERSONATION_SESSION_EVENT = 'support-impersonation-session-changed';

const emitSessionEvent = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(SUPPORT_IMPERSONATION_SESSION_EVENT));
};

export const getSupportImpersonationSession = (): SupportImpersonationSession | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(STORAGE_KEY);
    if (!rawValue) {
      return null;
    }

    const parsed = JSON.parse(rawValue) as SupportImpersonationSession;
    if (!parsed?.token || !parsed?.sessionId || !parsed?.targetUserId) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const setSupportImpersonationSession = (session: SupportImpersonationSession) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  emitSessionEvent();
};

export const clearSupportImpersonationSession = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(STORAGE_KEY);
  emitSessionEvent();
};

export const isSupportImpersonationErrorCode = (value: unknown): value is string => {
  return typeof value === 'string' && value.startsWith('support/');
};
